import respond from './utilities/respond'
import at from '../../actionTypes'

const votesActions = {
	votesFetchBegin: (uid, itemKey) => respond(at.VOTE_FETCH_BEGIN, { uid, itemKey }),
	votesFetchSuccess: votes => respond(at.VOTE_FETCH_SUCCESS, { votes }),
	votesFetchFail: (uid, itemKey) => respond(at.VOTE_FETCH_FAIL, { uid, itemKey })
}

export default votesActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/votesActions.js